import { jsx as o, jsxs as S } from "react/jsx-runtime";
import { useState as l } from "react";
import "@mui/material/Button";
import "@mui/material/styles";
import "@mui/material/CssBaseline";
import { d as P, I as Y } from "./DropdownMultipleSearch-DjTDrFWt.js";
import { Box as p, LinearProgress as j } from "@mui/material";
import { faXmark as F } from "@fortawesome/pro-regular-svg-icons";
import "@fortawesome/fontawesome-svg-core";
import "@mui/material/Box";
import "@mui/material/Checkbox";
import "@fortawesome/pro-solid-svg-icons";
import "@fortawesome/pro-light-svg-icons";
import "@mui/material/Stack";
import "@mui/material/Link";
import "@mui/material/Typography";
import "@mui/material/Tooltip";
import "@mui/material/Fade";
import "@fortawesome/pro-regular-svg-icons/faXmark";
import "@mui/material/useAutocomplete";
import "@emotion/cache";
import "@emotion/react";
import "@mui/material/Chip";
import "@fortawesome/pro-solid-svg-icons/faCircle";
import "@mui/material/Avatar";
import "@fortawesome/pro-light-svg-icons/faUser";
import "@mui/material/AvatarGroup";
import "@fortawesome/pro-regular-svg-icons/faPlus";
import "@mui/material/LinearProgress";
import "@mui/material/Tabs";
import "@mui/material/Tab";
import "@mui/material/ButtonGroup";
import "@mui/material/Switch";
import "@mui/material/Radio";
import "@mui/material/FormLabel";
import "@mui/material/Autocomplete";
import "@mui/material/FormHelperText";
import "@mui/material/FormControl";
import "@mui/material/OutlinedInput";
import "@mui/material/Input";
import "@mui/material/InputAdornment";
import "@fortawesome/pro-regular-svg-icons/faMagnifyingGlass";
import "@fortawesome/pro-solid-svg-icons/faCheck";
import "@fortawesome/pro-regular-svg-icons/faCircleQuestion";
import "@react-spring/web";
import "./ContentPanel-DRC79oum.js";
import "react-dropzone";
import "@vidstack/react";
import "@vidstack/react/player/layouts/default";
import "@vidstack/react/player/styles/default/theme.css";
import "@vidstack/react/player/styles/default/layouts/video.css";
import "@vidstack/react/icons";
import "@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare";
import "@fortawesome/pro-solid-svg-icons/faArrowRight";
import "@mui/material/Popper";
import "@fortawesome/pro-regular-svg-icons/faLinkSimple";
import "copy-text-to-clipboard";
import "@fortawesome/pro-solid-svg-icons/faExpandWide";
import "@fortawesome/pro-solid-svg-icons/faCompressWide";
import "@fortawesome/pro-solid-svg-icons/faUpRightAndDownLeftFromCenter";
import "@fortawesome/pro-solid-svg-icons/faDownLeftAndUpRightToCenter";
import "@fortawesome/pro-solid-svg-icons/faChevronsRight";
import "@fortawesome/pro-solid-svg-icons/faChevronsLeft";
import "@fortawesome/pro-solid-svg-icons/faToggleLargeOn";
import "@fortawesome/pro-solid-svg-icons/faToggleOff";
import "@fortawesome/pro-solid-svg-icons/faEye";
import "react-use";
import "color";
import { F as L, L as T, T as W } from "./ThankYouStep-D7VYBP-V.js";
import "react-rnd";
import "react-hotkeys-hook";
import "./AutoScrollContainer-CzyjIY1o.js";
import "@tanstack/react-table";
import "@fortawesome/pro-regular-svg-icons/faArrowRight";
import "@fortawesome/pro-regular-svg-icons/faArrowLeft";
import "@fortawesome/pro-regular-svg-icons/faPenToSquare";
import "@fortawesome/pro-regular-svg-icons/faCircleXmark";
import "@fortawesome/pro-regular-svg-icons/faArrowDown";
const r = {
  feedback: 0,
  singIn: 1,
  thankYou: 2
}, io = ({
  isLoading: a,
  onClose: h,
  authorName: m,
  authorPhotoURL: f = "",
  isMobileView: t,
  background: u = "",
  shouldHidePolicyAndTermsLink: g = !1,
  onPostClick: k,
  onPostAnonymously: x,
  onGoogleClick: c = void 0,
  onMicrosoftClick: s = void 0,
  onSingUpClick: d = void 0,
  termsLink: y,
  privacyPolicyLink: I,
  isBackgroundLight: b = !1
}) => {
  const [e, n] = l(r.feedback), [i, v] = l(`Thank you ${m} 👍!`);
  return /* @__PURE__ */ o(
    p,
    {
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ S(
        p,
        {
          maxWidth: t ? "calc(100% - 16px)" : "500px",
          maxHeight: `calc(100% - ${t ? 16 : 40}px)`,
          bgcolor: (C) => C.palette.background.paper,
          width: "100%",
          height: "auto",
          overflow: "hidden",
          borderRadius: "8px",
          position: "relative",
          display: t ? "flex" : "block",
          justifyContent: "center",
          alignItems: "center",
          children: [
            !!a && /* @__PURE__ */ o(
              p,
              {
                position: "absolute",
                top: 0,
                right: 0,
                left: 0,
                children: /* @__PURE__ */ o(j, {})
              }
            ),
            /* @__PURE__ */ o(
              p,
              {
                position: "absolute",
                top: t ? 0 : 14,
                right: t ? 8 : 14,
                children: /* @__PURE__ */ o(
                  P,
                  {
                    label: "Close",
                    onClick: h,
                    variant: "text",
                    color: "secondary",
                    size: "large",
                    children: /* @__PURE__ */ o(
                      Y,
                      {
                        icon: F,
                        size: "xs"
                      }
                    )
                  }
                )
              }
            ),
            e === r.feedback && /* @__PURE__ */ o(
              L,
              {
                authorName: m,
                setFeedback: v,
                isMobileView: t,
                feedback: i,
                onPost: () => {
                  k(i), n(r.singIn);
                }
              }
            ),
            e === r.singIn && /* @__PURE__ */ o(
              T,
              {
                authorName: m,
                isBackgroundLight: b,
                shouldHidePolicyAndTermsLink: g,
                authorPhotoURL: f,
                background: u,
                isMobileView: t,
                googleLabel: t ? "Google" : "Continue with Google",
                microsoftLabel: t ? "Microsoft" : "Continue with Microsoft",
                ...c && {
                  onGoogleClick: () => {
                    c(i);
                  }
                },
                ...s && {
                  onMicrosoftClick: () => {
                    s(i);
                  }
                },
                onPostAnonymously: () => {
                  x(i), n(r.thankYou);
                },
                ...d && {
                  onSingUpClick: () => {
                    n(r.thankYou), d(i);
                  }
                },
                termsLink: y,
                privacyPolicyLink: I,
                isLoading: a
              }
            ),
            e === r.thankYou && /* @__PURE__ */ o(W, { isMobileView: t })
          ]
        }
      )
    }
  );
};
export {
  io as P
};
